import type { EnumsResponse } from '@/api/enums'

/**
 * Ключи атрибутов слова (как `App\Enums\WordAttributes\WordAttributeKey` в API).
 * Используются в фильтрах теста / карточек. Порядок значений при наличии ответа `GET /enums` берётся с бэкенда (`WordAttributeKey`).
 */
const WORD_ATTRIBUTE_FILTER_KEYS_FALLBACK = [
  'transcription',
  'translation',
  'audio_path',
  'type',
  'part_of_speech',
  'example_sentence',
  'synonym',
  'antonym',
  'note',
] as const

export type WordAttributeFilterKey = (typeof WORD_ATTRIBUTE_FILTER_KEYS_FALLBACK)[number]

/** Статический список (например, для типов до загрузки enums). */
export const WORD_ATTRIBUTE_FILTER_KEYS = WORD_ATTRIBUTE_FILTER_KEYS_FALLBACK

export function getWordAttributeFilterKeys(
  enums: EnumsResponse | Record<string, unknown> | null | undefined,
): WordAttributeFilterKey[] {
  const list = enums && typeof enums === 'object' && 'WordAttributeKey' in enums ? (enums as EnumsResponse).WordAttributeKey : undefined
  if (Array.isArray(list) && list.length > 0) {
    const allowed = new Set<string>(WORD_ATTRIBUTE_FILTER_KEYS_FALLBACK)
    return list
      .map((o) => String(o.value))
      .filter((v): v is WordAttributeFilterKey => allowed.has(v))
  }
  return [...WORD_ATTRIBUTE_FILTER_KEYS_FALLBACK]
}
